
const helpers = {};

// Join class names, dropping the falsy ones. That lets a caller write
// clx(styles.row, isActive && styles.rowActive) instead of spelling out an empty
// string for the inactive branch: without the filter, join() renders a false
// straight into the class list as the literal "false".
//
// Every existing caller passes "" for that branch, so they get the string they
// always did minus a trailing space, which no DOM cares about.
helpers.clx = (...classes) => {
  return classes.filter(Boolean).join(" ");
}

// Local date, not toISOString(): that is UTC, so it gives yesterday's date
// shortly after midnight during BST.
helpers.toDateInputValue = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

helpers.errorPrompt = (errorPrompt, highlighedtInput, setErrorPrompt, setHighlighedtInput) => {
  if(setErrorPrompt !== null) {
    setErrorPrompt(errorPrompt);
  };
  if(setHighlighedtInput !== null) {
    setHighlighedtInput(highlighedtInput);
  } 
  setTimeout(() => {
    if(setErrorPrompt !== null) {
      setErrorPrompt("");
    }
    if(setHighlighedtInput !== null) {
      setHighlighedtInput("")
    } 
  }, 2000)
}

helpers.isValidEmail = (email) => {
  if (
    email.length === 0 ||
    email.split("@").length < 2 ||
    email.split(".").length < 2
  ){
    return false;
  }else{
    return true;
  }
}

// Weight, volume and indicative price for a bag count.
//
// BBB-524 fixed the discount here: "quarterly" fell through into "yearly" and
// every quarterly subscriber was scored 20% instead of 10%.
//
// Read this before wiring `priceDiscounted` into anything. Three things about
// it are not obvious, and all three were checked rather than assumed:
//
// 1. NOTHING READS `priceDiscounted`. The only caller is
//    ReviewSubscriptionScreen, which uses weight and volume only; its one price
//    line is commented out and renders the literal "n/a". That is why the
//    fall-through never mischarged anyone.
// 2. THE CLIENT NEVER SENDS A PRICE. handleSubmit posts bag counts and
//    billingPlan; bbb-server computes amount_due itself.
// 3. THE SERVER DOES NOT DISCOUNT THIS WAY. It keys a per-bag pound discount off
//    `contract_plan` (individual / oneYear / twoYears) via
//    SUBSCRIPTION_PLAN_DISCOUNTS. The percentages below key off billingPlan, the
//    payment cadence, which is a different axis entirely. Displaying this figure
//    next to a server-issued invoice would show a farmer two different numbers.
//
// The per-bag prices are also magic numbers and already diverge: 599 for
// pelletchar here, 260 in bbb-ops, while bbb-server carries BAG_BASE_PRICE 599
// and separate invoice prices of 400 and 600. Whoever unifies pricing owns that,
// and it is a commercial decision, not an engineering one.
helpers.estimateBiocharStats = (pincharBags, pelletcharBags, billingPlan) => {
  let stats = {};
  stats.weightPinchar = Math.round(pincharBags * 10 * 0.33)/10;
  stats.weightPelletchar = Math.round(pelletcharBags * 10 * 0.33)/10;
  stats.weightTotal = stats.weightPinchar + stats.weightPelletchar;
  stats.volumePinchar = pincharBags * 2;
  stats.volumePelletchar = pelletcharBags * 0.8;
  stats.volumeTotal = stats.volumePinchar + stats.volumePelletchar
  stats.pricePinchar = pincharBags * 80;
  stats.pricePelletchar = pelletcharBags * 599;
  stats.priceTotal = stats.pricePinchar + stats.pricePelletchar;
  let discount = 0;
  switch(billingPlan){
    case "monthly":
      break;
    case "quarterly":
      discount = stats.priceTotal * 0.10;
      break;
    case "yearly":
      discount = stats.priceTotal * 0.20;
      break;
    default:
      break;
  }
  stats.priceDiscounted = stats.priceTotal - discount;
  return stats;
} 

// Helper function to get marker icon based on marker type
helpers.getMarkerIcon = (markerType) => {
  // Import marker icons dynamically to avoid circular dependencies
  const iconMarkerBbb = require('./assets/images/iconMarkerBbb.png');
  const iconMarkerWheat = require('./assets/images/iconMarkerWheat.png');
  const iconMarkerCow = require('./assets/images/iconMarkerCow.png');
  const iconMarkerHousing = require('./assets/images/iconMarkerHousing.png');
  
  const markerIconMap = {
    'bbb': iconMarkerBbb,
    'wheat': iconMarkerWheat,
    'cow': iconMarkerCow,
    'dairy': iconMarkerCow,  // ✅ Map 'dairy' to cow icon
    'housing': iconMarkerHousing,
  };
  
  // Return the mapped icon or fallback to BBB icon
  return markerIconMap[markerType] || iconMarkerBbb;
};

export default helpers;
